import { useMediaQuery, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import { useCurrentPage } from '»utils/customHooks';

import HemeraBgLoginPage from '../../../assets/img/HEMERA_bg-login.webp';
import HemeraBgLPageSM from '../../../assets/img/HEMERA_bg-lpage-sm.webp';
import { GradientContainer } from '../AppCard.styles';
import {
  BackgroundMobileImageStyled,
  BoxBackgroundImageStyled,
  CardContainer,
  LandingPageSubTitle,
  LandingPageTitle,
  TextContainer,
} from './AppCardHemera.styles';

export const AppCardHemera = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const location = useLocation();

  const { isNoAuthFormPage, isLoginPage, isOnboardingAdvancedSteps } =
    useCurrentPage(location.pathname);

  if (isDesktop)
    return (
      <BoxBackgroundImageStyled
        isFormPage={isNoAuthFormPage}
        isLoginPage={isLoginPage}
        isOnboardingAdvancedSteps={isOnboardingAdvancedSteps}
      >
        <GradientContainer
          isOnboardingAdvancedSteps={isOnboardingAdvancedSteps}
        >
          <TextContainer isFormPage={isNoAuthFormPage}>
            <LandingPageTitle isFormPage={isNoAuthFormPage}>
              <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN_HEMERA" />
            </LandingPageTitle>
            <LandingPageSubTitle isFormPage={isNoAuthFormPage}>
              <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN_HEMERA2" />
            </LandingPageSubTitle>
          </TextContainer>
        </GradientContainer>
      </BoxBackgroundImageStyled>
    );

  return (
    <CardContainer isFormPage={isNoAuthFormPage}>
      <TextContainer isFormPage={isNoAuthFormPage}>
        <LandingPageTitle>
          <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN_HEMERA" />
        </LandingPageTitle>
        <LandingPageSubTitle>
          <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN_HEMERA2" />
        </LandingPageSubTitle>
      </TextContainer>
      <BackgroundMobileImageStyled
        alt="background-mobile-image"
        component="img"
        src={isLoginPage ? HemeraBgLoginPage : HemeraBgLPageSM}
        isFormPage={isNoAuthFormPage}
      />
    </CardContainer>
  );
};
